export default class Resize extends EventTarget {
    handle = null;
    started = false;
    times = 0;

    constructor() {
        super();

        window.addEventListener('resize', this.onResize);
        window.addEventListener('orientationchange', this.onResize);
    }

    off() {
        this.removeEventListener(...arguments);
    }

    on() {
        this.addEventListener(...arguments);
    }

    onResize = () => {
        if (!this.started) {
            this.started = true;
            this.times = 0;

            window.dispatchEvent(new CustomEvent('resize:start'));
        }

        if (this.handle != null) {
            this.times = 0;

            window.cancelAnimationFrame(this.handle);
        }

        const tick = () => {
            if (++this.times === 10) {
                this.handle = null;
                this.started = false;
                this.times = 0;

                window.dispatchEvent(new CustomEvent('resize:end'));
            } else {
                this.handle = window.requestAnimationFrame(tick);
            }
        };

        this.handle = window.requestAnimationFrame(tick);
    }

    destroy() {
        window.removeEventListener('resize', this.onResizeHandle);
        window.removeEventListener('orientationchange', this.onResizeHandle);

        this.removeAllListeners();
    }
}
